import gql from 'graphql-tag';

export const addEvidence = gql`
    mutation addEvidence($inputEvidence: [EvidenceInput!]!){
      response: addEvidence(inputEvidence: $inputEvidence){
        id
      }
    }
`;
